import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#FFF5E6",
                        color: "#2C1E16",
                        border: "1px solid #D4AF37",
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
